var React = require('react');

function IconStarHalf (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_2448","data-name":"Group 2448","transform":"translate(-1010 -2566.5)"},[React.createElement("path",{"id":"Path_1386","data-name":"Path 1386","d":"M1740,504.514l2.715,8.785h8.785l-7.107,5.43,2.715,8.785-7.107-5.43-7.107,5.43,2.715-8.785-7.107-5.43h8.785Z","transform":"translate(-718 2062.485)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_1745","data-name":"Path 1745","d":"M1740,504.514v17.57l-7.107,5.43,2.715-8.785-7.107-5.43h8.785Z","transform":"translate(-718 2062.485)","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})]));
}

IconStarHalf.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconStarHalf;

IconStarHalf.default = IconStarHalf;
